import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { MAIL_MENU_ITEM } from '../../../constant';
import { findAndMergeDefaultMenuConfig } from '../util';
import { getIn18Text } from 'api';
import { apis, apiHolder } from 'api';
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const MailMultOpConfig2AllFolder = [
    {
        key: MAIL_MENU_ITEM.MARK,
        group: '1',
        name: getIn18Text('BIAOJIWEI'),
        icon: undefined,
        onlyUnfold: true,
        show: mails => {
            return true;
        },
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.RED_FLAG,
                icon: undefined,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.READ,
                icon: undefined,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.WM_UNFOLLOW_STATIC,
                icon: undefined,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.WMFOLLOW_STATIC,
                icon: undefined,
                group: '2',
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.DELETE,
        icon: undefined,
        group: '1',
    },
];
export default findAndMergeDefaultMenuConfig(MailMultOpConfig2AllFolder, DefaultMailMenuConfig);
